module.exports = __webpack_public_path__ + "static/10-d6550b157dacf12ba6e1a1365e54a0f7.jpeg";